import styled from "styled-components";

const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 15%);
  flex-wrap: wrap;
  grid-column-gap: 10px;
  max-height: 210px;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 3% 5%;

  @media (max-width: 800px) {
    grid-template-columns: repeat(4, 25%);
  }

  @media (max-width: 576px) {
    grid-template-columns: repeat(2, 50%);
  }

  .filter {
    display: flex;
    align-items: center;

    input {
      margin-right: 6px;
    }
  }
`;

export default FiltersContainer;
